export const RECEIPT_ACCEPTED_TYPE = 'application/pdf';
export const RECEIPT_ACCEPT_ATTRIBUTE = '.pdf,application/pdf';
export const RECEIPT_MAX_SIZE_MB = 10;
const RECEIPT_MAX_SIZE_BYTES = RECEIPT_MAX_SIZE_MB * 1024 * 1024;

export const RECEIPT_TYPE_ERROR = 'O recibo precisa ser um arquivo PDF.';
export const RECEIPT_SIZE_ERROR = `O arquivo passa de ${RECEIPT_MAX_SIZE_MB} MB. Envie uma versão menor.`;
export const RECEIPT_EMPTY_ERROR = 'O arquivo está vazio.';

export function validateReceiptFile(file: File): string | null {
    if (file.size === 0) return RECEIPT_EMPTY_ERROR;
    if (file.size >= RECEIPT_MAX_SIZE_BYTES) return RECEIPT_SIZE_ERROR;

    const typeMatches = file.type === RECEIPT_ACCEPTED_TYPE;
    const extensionMatches = file.name.toLowerCase().endsWith('.pdf');
    if (!typeMatches && !extensionMatches) return RECEIPT_TYPE_ERROR;

    return null;
}

export function sanitizeReceiptFileName(fileName: string): string {
    const normalized = fileName
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/[^a-zA-Z0-9._-]+/g, '-')
        .replace(/-+/g, '-')
        .replace(/^-|-$/g, '');

    return normalized || 'recibo.pdf';
}

export function buildReceiptStoragePath(
    collaboratorId: string,
    fileName: string,
    stamp: number
): string {
    return `vacations/${collaboratorId}/receipts/${stamp}_${sanitizeReceiptFileName(fileName)}`;
}

export function formatFileSize(bytes: number): string {
    if (bytes < 1024) return `${bytes} B`;
    if (bytes < 1024 * 1024) return `${Math.round(bytes / 1024)} KB`;
    return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}
